<template>
  <div style="border-color: #E6EBEF;"
       class="h-16 rounded-lg px-3 flex justify-between"
       :class="[showButtons ? 'border' : 'bg-red-50']"
  >
    <div class="min-w-0 flex-1 flex justify-between items-center gap-4">
      <button @click.stop="$emit('click', note)" class="px-2 text-left" style="color: #4A5A69;">
        <p style="color: #2E3842; line-height: 24px;" class="text-lg font-bold">{{ note.title }}</p>
        <p style="font-size: 13px; color: #2E3842; line-height: 20px;" v-if="showButtons">{{formattedDuration(note.startDate, note.endDate)}}</p>
      </button>
      <div v-if="!showButtons" class="pr-3 flex items-center gap-x-2">
        <span style="color: #FF5353;" class="text-lg">{{meetingNoteDurationForm}}</span>
        <button style="background-color: #FF5353;"
                class="h-9 text-white font-bold rounded-full px-6 flex items-center"
                @click.stop="onClickMeetingNoteStop(note)"
        >{{ this.$t("extendMenu.meetingNote.summary.stop" )}}</button>
      </div>
    </div>
    <div v-if="showButtons" class="flex items-center space-x-8">
      <div class="space-x-8 flex items-center">
<!--        <button v-if="!note.isSaving" style="color: #4A5A69;"-->
<!--                class="flex items-center gap-x-1 text-sm font-bold"-->
<!--                @click.stop="onClickMeetingNoteDownload(note)"-->
<!--        >-->
<!--          회의록-->
<!--          <img width="22" height="22" class="pointer-events-none" :src="require('@/assets/images/meeting-note/download_gray.svg')" />-->
<!--        </button>-->
        <div v-if="note.isSaving" style="color: #4A5A69;"
                class="flex items-center gap-x-1 text-sm font-bold whitespace-nowrap"
        >{{ this.$t("extendMenu.meetingNote.summary.saving" )}}<GrmLoadingCircle size="xs" /></div>
        <button v-if="note.summaryState === 'notStarted'"
                style="color: #4A5A69;"
                class="text-sm font-bold whitespace-nowrap"
                @click.stop="onClickRequestSummary(note)"
        >
          {{ this.$t("extendMenu.meetingNote.summary.create" )}}
        </button>
        <button style="color: #4A5A69;"
                class="flex items-center gap-x-1 text-sm font-bold whitespace-nowrap	"
                v-else-if="note.summaryState === 'completed' || note.summaryState === 'pending'"
                @click.stop="onClickSummaryDownload(note)">
          {{ this.$t("extendMenu.meetingNote.summary.title" )}}
          <img v-if="note.summaryState === 'completed'"
               width="22" height="22" class="pointer-events-none" src="@/assets/images/meeting-note/download_gray.svg"/>
          <GrmLoadingCircle v-if="note.summaryState === 'pending'"
                            size="xs"
          />
        </button>
        <button class="text-red-400"
                v-else-if="note.summaryState === 'failed'"
                @click.stop="onClickFailedSummary(note)">
          {{ this.$t("extendMenu.meetingNote.summary.fail" )}}
        </button>
      </div>
<!--      <button class="w-10 h-10 flex justify-center items-center"-->
<!--              @click.stop="remove(note)"-->
<!--      >-->
<!--        <img width="24" height="24" class="pointer-events-none" :src="require('@/assets/images/meeting-note/trashcan.svg')" />-->
<!--      </button>-->
      <button @click="onToggleIsOpenList" class="ai-item-more-toggle-button">
        <img width="16" height="16" class="pointer-events-none" :src="require('@/assets/images/more.svg')" />
      </button>
      <div class="ai-item-more-button">
        <div class="absolute top-3/4 right-0">
          <GrmMenu :list="aiMoreList" :open.sync="isOpenList" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment/moment";
import {mapActions, mapGetters} from "vuex";
import GrmLoadingCircle from "@/components/Common/loading/GrmLoadingCircle.vue";
import GrmMenu from "@/components/Common/menu/GrmMenu.vue";

export default {
  name: 'RoomMeetingNoteItem',
  components: {
    GrmMenu,
    GrmLoadingCircle,
  },
  props: {
    note: Object,
    showButtons: {
      type: Boolean,
      default: true
    },
  },
  data(){
    return {
      isOpenList: false,
    }
  },
  computed: {
    ...mapGetters('meetingNote', [
      'writingTime',
      'ongoingMeetingNote',
    ]),
    ...mapGetters('user', [
      'getUsername',
    ]),
    aiMoreList(){
      return [
        {
          title: this.$t("extendMenu.meetingNote.download.title"),
          disabled: this.note.isSaving,
          click: () => {
            if(this.note.isSaving){
              return
            }
            this.onClickMeetingNoteDownload(this.note)
          }
        },
        {
          title: this.$t("extendMenu.meetingNote.delete.title"),
          click: () => {
            this.remove(this.note)
          }
        }
      ];
    },
    meetingNoteDurationForm(){
      let mo = moment.utc(0).millisecond(this.writingTime);
      let minutes = mo.hours() * 60 + mo.minutes();
      if(minutes < 10){
        minutes = '0' + minutes
      }
      return minutes + mo.format(':ss');
    },
    formattedDate() {
      return date => {
        return date && moment(date).format('HH:mm');
      }
    },
    formattedDuration() {
      return (a, b) => {
        if(!b){
          return `${this.formattedDate(a)}~`
        }else{
          return `${this.formattedDate(a)}~${this.formattedDate(b)}`
        }
      }
    },
    isEnded() {
      return meetingNote => {
        return !!meetingNote.endDate;
      }
    },
    getFormedDate() {
      return date => {
        return moment(date).format('YYYY-MM-DD HH:mm');
      }
    },
    getFormedTime() {
      return date => {
        return moment(date).format('HH:mm');
      }
    },
  },
  methods: {
    ...mapActions('meetingNote', [
      'startMeetingNote',
      'stopMeetingNote',
      'summarizeMeetingNote',
      'getMeetingNoteSummary',
      'getMeetingNote',
      'deleteMeetingNote',
    ]),
    onClickMeetingNoteStop(meetingNote) {
      return this.$alert({
        text: this.$t('extendMenu.meetingNote.quit'),
        ok:() => {
          this.stopMeetingNote(this.ongoingMeetingNote);
        },
      })
    },
    onClickRequestSummary(meetingNote) {
      if(meetingNote.isSaving || this.ongoingMeetingNote?.meetingNoteId === meetingNote.meetingNoteId){
        return this.$alert({
          text: this.$t('extendMenu.meetingNote.ongoing.summary'),
          onlyOk: true,
        });
      }else{
        let alertText = '오류가 발생하였습니다. 관리자에게 문의해주세요.';
        switch (meetingNote.summaryState) {
          case 'failed':
          case 'notStarted':
            return this.$alert({
              text: this.$t('extendMenu.meetingNote.summary.alert.start'),
              ok: () => {
                this.summarizeMeetingNote(meetingNote)
              },
            });
          case 'pending':
            alertText = this.$t('extendMenu.meetingNote.summary.alert.ongoing')
            break;
          case 'completed':
            alertText = this.$t('extendMenu.meetingNote.summary.alert.complete')
            break;
        }
        return this.$alert({
          text: alertText,
          onlyOk: true,
        });
      }
    },
    async onClickSummaryDownload(meetingNote) {
      if(meetingNote.summaryState === 'completed'){
        let data = await this.getMeetingNoteSummary(meetingNote)

        // TODO 데모용 회의록 요약 파일 생성 로직
        const messages = [
          `${this.$t('extendMenu.meetingNote.meetingDate')}: ${this.getFormedDate(data.startDate)} ~ ${this.getFormedTime(data.endDate)}\n`,
          `${this.$t('extendMenu.meetingNote.writer')}: ${this.getUsername(data.userId) || this.$t('extendMenu.meetingNote.leavedUser')}\n`,
          `${this.$t('extendMenu.meetingNote.summary.content')}: ${data.summary}`
        ]
        const blob = new Blob(messages, {type: 'text/plain', endings: 'native'});
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        try{
          a.href = url;
          a.download = `${moment(meetingNote.startDate).format('YYMMDD_hhmm')}_${this.$t('extendMenu.meetingNote.summaryNote')}.txt`;
          document.body.append(a);
          a.click();
        }finally{
          window.URL.revokeObjectURL(url);
          a.remove();
        }

        return;
      }

      let alertText;
      switch (meetingNote.summaryState) {
        case 'failed':
          alertText = this.$t('extendMenu.meetingNote.download.fail')
          break;
        case 'notStarted':
          alertText = this.$t('extendMenu.meetingNote.download.notStarted')
          break;
        case 'pending':
          alertText = this.$t('extendMenu.meetingNote.download.pending')
          break;
      }
      return this.$alert({
        text: alertText,
        onlyOk: true,
      });
    },
    onClickFailedSummary(meetingNote) {
      return this.$alert({
        text: 'AI회의록 생성에 실패하였습니다. 다시 생성하시겠습니까?',
        ok: () => {
          this.onClickRequestSummary(meetingNote)
        },
      });
    },
    async onClickMeetingNoteDownload(meetingNote) {
      if(this.ongoingMeetingNote?.meetingNoteId === meetingNote.meetingNoteId){
        return this.$alert({
          text: this.$t('extendMenu.meetingNote.ongoing.download'),
          onlyOk: true,
        });
      }else{
        let data = await this.getMeetingNote(meetingNote);

        // TODO 회의록 원본 파일 생성 로직 - 데모용 임시
        const rows = data.map(row => ({
          name: this.getUsername(row.userId) || this.$t('extendMenu.notice.leavedUser'),
          regDate: row.regDate,
          duration: row.duration,
          text: row.text,
        }));

        const XLSX = await import('xlsx');
        const workSheet = XLSX.utils.json_to_sheet(rows);
        XLSX.utils.sheet_add_aoa(workSheet, [[this.$t('common.name'), this.$t('extendMenu.meetingNote.regDate'), this.$t('extendMenu.meetingNote.speakTime'), this.$t('extendMenu.meetingNote.content')]], {origin: "A1"})

        workSheet["!cols"] = [
          {wch: 20},
          {wch: 18},
          {wch: 5},
          {
            wch: 100,
            alignment: {
              vertical: "center",
              horizontal: "center",
              wrapText: true, // any truthy value here
            },
          },
        ];

        const workBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workBook, workSheet, this.$t('extendMenu.meetingNote.title'))

        XLSX.writeFile(workBook, `${moment(meetingNote.startDate).format('YYMMDD_hhmm')}_${this.$t('extendMenu.meetingNote.title')}.xlsx`, { compression: true });
        return;
      }
    },
    remove(meetingNote) {
      if(!meetingNote.endDate){
        return this.$alert({
          text: this.$t('extendMenu.meetingNote.delete.ongoing'),
          ok: () => {
            this.stopMeetingNote(meetingNote);
          },
        })
      }else if(meetingNote.summaryState === 'pending'){
        return this.$alert({
          text: this.$t('extendMenu.meetingNote.delete.pending'),
          ok: () => {
            this.deleteMeetingNote(meetingNote);
          },
        })
      } else{
        return this.$alert({
          title: this.$t('extendMenu.meetingNote.delete.description'),
          text: this.$t('extendMenu.meetingNote.delete.text'),
          ok: () => {
            this.deleteMeetingNote(meetingNote);
          },
        })
      }
    },
    onToggleIsOpenList(){
      this.isOpenList = !this.isOpenList;
    }
  }
}
</script>

<style lang="scss" scoped>
.ongoing-badge {
  background-color: #FF5353;
}
.ai-item-more-button{
  position: relative;
}
.ai-item-more-toggle-button{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
}
</style>